import { render, staticRenderFns } from "./SettingSms.vue?vue&type=template&id=549912f2"
import script from "./SettingSms.vue?vue&type=script&lang=js"
export * from "./SettingSms.vue?vue&type=script&lang=js"
import style0 from "./SettingSms.vue?vue&type=style&index=0&id=549912f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports